export default __webpack_public_path__ + "static/media/Circle.5babee69.svg";